export enum LineActionTypes {
  SET_LINE_USER_INFO_PENDING = '@@line/SET_LINE_USER_INFO_PENDING',
  SET_LINE_USER_INFO_SUCCESS = '@@line/SET_LINE_USER_INFO_SUCCESS',
  SET_LINE_USER_INFO_ERROR = '@@line/SET_LINE_USER_INFO_ERROR',
  SET_ONBOARDING_PENDING = '@@line/SET_ONBOARDING_PENDING',
  SET_ONBOARDING_SUCCESS = '@@line/SET_ONBOARDING_SUCCESS',
  SET_ONBOARDING_ERROR = '@@line/SET_ONBOARDING_ERROR',
}
